<header class="sub-header mb-3">
  <h5>Navigation Role Mapping</h5>
</header>
<div mat-dialog-content>
  <div class="p-3 card" >
    <div fxLayout="row">
      <form [formGroup]="form" (ngSubmit)="onUserSubmit(form.value)">
        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-12">
            <mat-form-field class="w-100" appearance="outline">
              <mat-select placeholder="Roles" name="Parent" formControlName="roleId">
                <mat-select-search autocomplete="off" placeholder="Search Roles" [formControl]="RoleListCtrl">
                </mat-select-search>
                <mat-option *ngFor="let mile of this.roles" [value]="mile.id"
                  >
                  {{mile.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('roleId')?.hasError('required')">
                Role is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-lg-6 col-sm-12">
            <mat-form-field class="w-100" appearance="outline">
              <mat-select placeholder="Source" (selectionChange)="changeSource($event)" [ngModelOptions]="{standalone: true}" [(ngModel)] = "source">
                <mat-option *ngFor="let mile of Source" [value]="mile.id">
                  {{mile.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-lg-6 col-sm-12">
            <mat-form-field  class="w-100" appearance="outline">
              <input matInput autocomplete="off" placeholder="Search Navigation Links" [formControl]="LinkListCtrl">
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
    <div class="row">
      <span *ngFor="let mile of data; let i = index" class="col-md-2">
        <input type="checkbox" [(ngModel)]="mile.isAdmin" [ngModelOptions]="{standalone: true}"
          (click)="getCheckedValue($event , mile)">
        {{mile.title}}
      </span>
      <span *ngIf="this.data.length == 0" class="col-md-3">
        <h3> No Data Found....</h3>
      </span>
    </div>
    
    <div class="button-container">
      <button type="submit" class="btn btn-save btn-icon-text mb-2 mb-md-0 me-2" (click)="onUserSubmit(form.value)">
        <mat-icon>{{navLinkRoleId == '0' ? 'save' : 'save'}}</mat-icon>
        <span>{{navLinkRoleId == '0' ? 'Save' : 'Update'}}</span>
      </button>
      <button (click)="closeDialog()" class="btn btn-cancel btn-icon-text mb-2 mb-md-0">
        <mat-icon>cancel</mat-icon> Cancel
      </button>

    </div>
  </div>

</div>